module.exports = __webpack_public_path__ + "img/1698343544060.231847b5.jpg";